// import { createSelector } from 'reselect'

const getState = state => state.modal
const modalStateSelector = state => getState(state).open
const modalTypeSelector = state => getState(state).type
const dataSelector = state => getState(state).data

export {
  modalStateSelector,
  modalTypeSelector,
  dataSelector
}


// WEBPACK FOOTER //
// ./src/reduxModules/selectors/ModalSelectors.js